import { render, staticRenderFns } from "./aktivenCriminalRecordCertificateEditor.vue?vue&type=template&id=2d657ad6&"
import script from "./aktivenCriminalRecordCertificateEditor.vue?vue&type=script&lang=js&"
export * from "./aktivenCriminalRecordCertificateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports